module.exports = __webpack_public_path__ + "img/Group 28.86376e47.svg";